import { Repository } from 'src/components/types';
import { Dispatch } from 'src/types/state';
import urls from 'src/urls/source';
import authRequest from 'src/utils/fetch';

import { SrcDirMetadataLookup } from '../types';

import { FetchSourceDirMetadata } from './';

const fetchPage = (
  url: string,
  dirMetadata: SrcDirMetadataLookup = {}
): Promise<SrcDirMetadataLookup> =>
  fetch(authRequest(url))
    .then(response => (response.ok ? response.json() : Promise.reject()))
    .then(json => {
      const entries = {};

      // @ts-ignore TODO: fix noImplicitAny error here
      json.values.forEach(x => {
        const pathParts = x.path.split('/');
        // @ts-ignore TODO: fix noImplicitAny error here
        entries[pathParts[pathParts.length - 1]] = {
          size: x.size,
          lastModified: x.last_modified,
        };
      });

      if (json.next) {
        return fetchPage(json.next, { ...dirMetadata, ...entries });
      }

      return { ...dirMetadata, ...entries };
    });

export default (repository: Repository, ref: string, path: string) =>
  (dispatch: Dispatch) => {
    dispatch({ type: FetchSourceDirMetadata.REQUEST, payload: { ref, path } });
    const url = urls.api.internal.sourceWithMetadata(
      repository.full_name,
      ref,
      path
    );

    fetchPage(url).then(
      srcDirMetadata => {
        dispatch({
          type: FetchSourceDirMetadata.SUCCESS,
          payload: {
            ref,
            path,
            srcDirMetadata,
          },
        });
      },
      () => {
        dispatch({
          type: FetchSourceDirMetadata.ERROR,
          error: true,
        });
      }
    );
  };
